/**
 * Display humanization for the UI (Spec §5.1). A single lever over the canonical
 * `humanizeLabel`, applied at RENDER sites only — identity, references, search
 * matching, filtering, and sorting must keep the RAW identifier.
 *
 *   displayLabel("OrderManagement") -> "Order Management"
 *   displayPath("Orders.charge")    -> "Orders.Charge"  (per-segment)
 */
import { humanizeLabel } from "@archlang/scene/arch-model";

export const displayLabel = humanizeLabel;

/** Humanize each dotted segment of a qualified path for display. */
export function displayPath(dotted: string): string {
  return dotted
    .split(".")
    .map((seg) => humanizeLabel(seg))
    .join(".");
}
